import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { NgwWowService } from 'ngx-wow';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { getEmployeeView_Model } from 'src/app/modules/shared/components/employee-view/selectors';

@Component({
  selector: 'app-employee-details-view',
  templateUrl: './employee-view.component.html',
  styleUrls: ['./employee-view.component.scss'],
  host: {
    class: 'w-100'
  }
})
export class EmployerDetailsViewComponent extends ComponentBase implements OnInit, OnDestroy {
  employeeId: number = 0;
  employmentId: number = 0;
  data$ = this.store.pipe(select(getEmployeeView_Model));

  constructor(public store: Store<AppState>,
    public activatedRoute: ActivatedRoute,
    private wowService: NgwWowService,
    private router: Router
  ) {
    super();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.wowService.init();
    });

  }
  certificateOfEmploymentId
  ngOnInit() {
    super.ngOnInitBase();

    this.getRouteParam(this.activatedRoute, 'id', (id) => {
      this.employeeId = id;
    });
    this.getRouteParam(this.activatedRoute, 'employmentId', (id) => {
      this.employmentId = id;
    });

    this.screenWidthChange(this.store, (width: number) => {

    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  onEmployeeEditClick() {
    this.router.navigate(['employee-edit', this.employeeId, this.employmentId]);
  }
}
